import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'

export default function RegisterPage() {
  const { loginWithRedirect, isAuthenticated } = useAuth0()

  useEffect(() => {
    if (!isAuthenticated) {
      loginWithRedirect({
        authorizationParams: {
          screen_hint: 'signup'
        }
      })
    }
  }, [isAuthenticated, loginWithRedirect])

  return null
}